// extracted by mini-css-extract-plugin
export default {"applicationInfoItem":"ApplicationInfoFieldItem_applicationInfoItem__-gvRX","infoItemValue":"ApplicationInfoFieldItem_infoItemValue__m047S"};